export default {
    name: "light",
    colors: {
        primary: "",
        secondary: "",
        background: "#fff",

        separator: "#F2F2F2",

        hover_chat: "#F3F3F5",
        focus_textarea: "#AA83FF",

        quoted_background: "#F3F3F5",

        name_user: "#3d3d42",
        message_content: "#626264",
    }
}